import React from 'react'

const PrivacyPolice = () => {
    return (
        <div className="contact_us">
            <h3 className="title">Volt Privacy Policy</h3>
            <iframe
                src={`${process.env.REACT_APP_API_URL}user/content/privacy-policy`}
                style={{ width: "100%", height: "500px" }}
            />
        </div>
    )
}

export default PrivacyPolice